import { LabelKey, LabelTextValue } from '.'

interface Props {
  name: string
  link: string
}
export const Publisher: React.FC<Props> = ({ name, link }) => {
  return (
    <div className="sm:flex sm:pb-[6px] w-full text-[15px] sm:text-base leading-9 sm:leading-base align-top sm:align-middle">
      <LabelKey text="出版社" />
      <LabelTextValue
        text={name}
        outerLink={link}
        outerLinkText="出版社ページへ"
      />
    </div>
  )
}
